"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgGenerateOnePromoCodeOperationCtl = /** @class */ (function (_super) {
    __extends(DlgGenerateOnePromoCodeOperationCtl, _super);
    function DlgGenerateOnePromoCodeOperationCtl() {
        return _super.call(this, true) || this;
    }
    DlgGenerateOnePromoCodeOperationCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            promo_type_title: "",
            title: "",
            visible: false
        };
    };
    DlgGenerateOnePromoCodeOperationCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgGenerateOnePromoCodeOperationCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgGenerateOnePromoCodeOperationCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgGenerateOnePromoCodeOperationCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgGenerateOnePromoCodeOperationCtl.prototype.SetOnYesClick = function (callback) {
        this.DATA.onYes = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgGenerateOnePromoCodeOperationCtl.prototype, "onYesClick", {
        get: function () {
            return this.DATA.onYes;
        },
        enumerable: true,
        configurable: true
    });
    DlgGenerateOnePromoCodeOperationCtl.prototype.SetTitle = function (title) {
        this.DATA.title = title;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgGenerateOnePromoCodeOperationCtl.prototype, "Title", {
        get: function () {
            return this.DATA.title;
        },
        enumerable: true,
        configurable: true
    });
    DlgGenerateOnePromoCodeOperationCtl.prototype.SetPromoTypeTitle = function (title) {
        this.DATA.promo_type_title = title;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgGenerateOnePromoCodeOperationCtl.prototype, "PromoTypeTitle", {
        get: function () {
            return this.DATA.promo_type_title;
        },
        enumerable: true,
        configurable: true
    });
    return DlgGenerateOnePromoCodeOperationCtl;
}(BaseController_1.BaseController));
exports.DlgGenerateOnePromoCodeOperationCtl = DlgGenerateOnePromoCodeOperationCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgGenerateOnePromoCodeOperationCtl.ts
// module id = 906
// module chunks = 0